import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListResponse } from '@ca/core/models';
import { Observable, of, zip } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ModuleV1Read } from '../models/module-v1-read.model';
import { ModulesV1Service } from './modules-v1.service';

@Injectable()
export class ModulesPublicServiceV1 extends ModulesV1Service {
    apiUrl = 'module_manager/v1/public/modules';

    /**
     * Returns an Observable that emits a list of modules
     * @param params: HTTP params used for the request
     */
    getPublicModules(params?: HttpParams): Observable<ListResponse<ModuleV1Read>> {
        return this.http.get(this.endpoint, { params, headers: { 'Content-Type': 'application/query.api+json' } }).pipe(
            switchMap((res: ListResponse<ModuleV1Read>) => {
                const ids = res.data.map(entity => entity.producerId);
                return zip(this.userService.getUserInfos$(ids), of(res));
            }),
            map(zipped => {
                const [userInfos, modules] = zipped;
                modules.data.forEach((module: ModuleV1Read) => {
                    module.author = userInfos.find(user => user.id === module.producerId);

                    // Correctly initialize module
                    module = new ModuleV1Read(module);
                });
                return modules;
            }),
        );
    }

    protected createNewInstance(): ModuleV1Read {
        return new ModuleV1Read();
    }
}
